import axios from '@/api/config'

const agentTouristInfo = {
  pageList (data) {
    return axios.post(`${process.env.BASE_URL}/agentTouristInfo/pageList` , data)
  },
  getAgentTouristInfo (data) {
    return axios.get(`${process.env.BASE_URL}/agentTouristInfo/getAgentTouristInfo` , {params: data})
  },
  updateAgentTouristInfo (data) {
    return axios.put(`${process.env.BASE_URL}/agentTouristInfo/updateAgentTouristInfo` , data)
  },

}

export default agentTouristInfo



// WEBPACK FOOTER //
// ./src/api/agentTouristInfo.js